import PropTypes from 'prop-types'
import React from 'react'

import { ListItem } from 'twyne-new.ui'

const BlockPropTypes = {
  title: PropTypes.string,
  icon: PropTypes.func,
  dragReference: PropTypes.func,
  extraStyles: PropTypes.object,
}

export default function Block({ title, icon: Icon, dragReference }) {
  return <ListItem ref={dragReference} className='justify-start font-bold'>
    <Icon size="16" className="mr-2" />
    <span className='capitalize'>{title?.replaceAll('-', ' ')}</span>
  </ListItem>
}

Block.propTypes = BlockPropTypes
